enum Gender {
    Male = 'Male',
    Female = 'Female',
}

export default Gender;
